const getInputTypeFormName = (field_id) => 'input_types.' + field_id;

export default getInputTypeFormName